import React, { useState, useEffect } from "react";
import {
  HiOutlineMail,
  HiOutlineBuildingOffice2,
  HiOutlineGlobeAlt,
} from "react-icons/hi2";
import { FiAward, FiUser, FiEdit, FiPhoneCall } from "react-icons/fi";
import { RiDeleteBin6Line, RiExchangeFundsLine } from "react-icons/ri";
import { IoEyeOutline } from "react-icons/io5";
import axios from "axios";
import DeleteClientModal from "../../../components/Modals/DeleteClientModal";
import ClientStatusModal from "../../../components/Modals/ClientStatusModal";
import ViewModal from "../../Modals/ViewModal";
import EditConsultantModal from "../../Modals/EditConsultantModal";
import { FaIdCard } from "react-icons/fa";

const ConsultantEnquiries = ({ query, page, itemsPerPage, onDataChange }) => {
  const [loading, setLoading] = useState(false);
  const [consultants, setConsultants] = useState([]);
  const [selectedConsultant, setSelectedConsultant] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);

  useEffect(() => {
    fetchConsultant();
  }, []);

  const fetchConsultant = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/consultant-enquiry/get-all`
      );
      setConsultants(response.data || []);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredData = consultants.filter(
    (item) =>
      item.consultantName?.toLowerCase().includes(query.toLowerCase()) ||
      item.email?.toLowerCase().includes(query.toLowerCase()) ||
      item.companyName?.toLowerCase().includes(query.toLowerCase())
  );

  const startIndex = (page - 1) * itemsPerPage;
  const paginatedConsultants = filteredData.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  useEffect(() => {
    onDataChange(totalPages, filteredData.length);
  }, [filteredData.length, totalPages]);

  const handleDelete = async () => {
    try {
      const idToDelete = selectedConsultant._id || selectedConsultant.id;
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/consultants/delete-consultant/${idToDelete}`
      );
      setShowDeleteModal(false);
      fetchConsultant();
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  const handleEditSubmit = async (updatedData) => {
    try {
      const id = selectedConsultant._id || selectedConsultant.id;
      await axios.put(
        `${process.env.REACT_APP_API_URL}/consultants/edit-consultant/${id}`,
        updatedData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      setShowEditModal(false);
      setSelectedConsultant(null);
      fetchConsultant();
    } catch (err) {
      console.error("Edit submit error:", err);
    }
  };

  const handleViewDetails = (consultant) => {
    setSelectedConsultant(consultant);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setSelectedConsultant(null);
  };

  const handleStatusModalClose = () => {
    setShowStatusModal(false);
    fetchConsultant();
  };

  return (
    <section className="px-2 mb-4">
      {loading ? (
        <div className="text-center py-6 text-gray-600">Loading...</div>
      ) : paginatedConsultants.length === 0 ? (
        <div className="flex justify-center">
          <p className="p-4 text-gray-500">No consultant enquiries found.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
          {paginatedConsultants.map((consultant, index) => (
            <div
              key={index}
              className="relative flex justify-between items-center border-2 p-4 rounded-md bg-white shadow-lg"
            >
              <div>
                {/* Action Buttons */}
                {/* <div className="absolute top-2 right-2 flex gap-2">
                  <button
                    onClick={() => handleViewDetails(consultant)}
                    className="text-gray-600 hover:text-gray-800 transition-colors"
                    aria-label="View consultant details"
                  >
                    <IoEyeOutline className="h-5 w-5" />
                  </button>
                  <button
                    onClick={() => {
                      setSelectedConsultant(consultant);
                      setShowEditModal(true);
                    }}
                    className="text-blue-600 hover:text-blue-800 transition-colors"
                    aria-label="Edit consultant"
                  >
                    <FiEdit className="h-5 w-5" />
                  </button>
                  <button
                    onClick={() => {
                      setSelectedConsultant(consultant);
                      setShowDeleteModal(true);
                    }}
                    className="text-red-600 hover:text-red-800 transition-colors"
                    aria-label="Delete consultant"
                  >
                    <RiDeleteBin6Line className="h-5 w-5" />
                  </button>
                  <button
                    onClick={() => {
                      setSelectedConsultant(consultant);
                      setShowStatusModal(true);
                    }}
                    className="text-primaryColor hover:opacity-80 transition-opacity"
                    aria-label="Change consultant status"
                  >
                    <RiExchangeFundsLine className="h-5 w-5" />
                  </button>
                </div> */}

                {/* Consultant Info */}
                <h1 className="font-medium text-xl text-gray-700">
                  {consultant.consultantName}
                </h1>
                <p className="text-gray-500 text-xs">{consultant.email}</p>

                <div className="mt-4 space-y-2">
                  <div className="flex items-center gap-2">
                    <HiOutlineBuildingOffice2 size={18} />
                    <p className="text-gray-500">{consultant.companyName}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaIdCard size={18} />
                    <p className="text-gray-500">
                      {consultant.aadharCard || "0000 0000 0000"}
                    </p>
                  </div>
                  <div className="flex items-center gap-2">
                    <HiOutlineGlobeAlt size={18} />
                    <p className="text-gray-500">{consultant.country}</p>
                  </div>

                  <div className="flex items-center gap-2">
                    <FiPhoneCall size={18} />
                    <p className="text-gray-500">{consultant.phone}</p>
                  </div>
                </div>
              </div>

              {/* Consultant Image */}
              <img
                src={consultant?.companyRegistrationProof}
                alt="Consultant"
                className="w-24 mt-4 border-2 border-gray-300 rounded-md"
              />
            </div>
          ))}
        </div>
      )}

      {/* Modals */}
      {showDeleteModal && (
        <DeleteClientModal
          itemName={selectedConsultant?.consultantName}
          onConfirm={handleDelete}
          onClose={() => setShowDeleteModal(false)}
        />
      )}

      {showEditModal && (
        <EditConsultantModal
          mode="edit"
          initialData={selectedConsultant}
          onClose={() => setShowEditModal(false)}
          onSubmit={handleEditSubmit}
        />
      )}

      {showStatusModal && (
        <ClientStatusModal
          client={{ name: selectedConsultant?.consultantName }}
          onClose={handleStatusModalClose}
        />
      )}

      {showViewModal && (
        <ViewModal
          consultant={selectedConsultant}
          onClose={handleCloseViewModal}
        />
      )}
    </section>
  );
};

export default ConsultantEnquiries;
